import { useCallback, useMemo } from "react";
import { Box, MenuItem, TextField } from "@mui/material";
import { kayttokohdeOptions, labelFor } from "src/utils/quote/quoteConstants";
import { useT } from "src/i18n";

function RichItem({ option }) {
    if (!option.description) {
        return <Box sx={{ fontWeight: 500 }}>{option.label}</Box>;
    }
    return (
        <Box sx={{ flex: 1, minWidth: 0, py: 0.25 }}>
            <Box sx={{ fontWeight: 600, fontSize: 14, lineHeight: 1.3 }}>
                {option.label}
            </Box>
            <Box sx={{ fontSize: 12, color: "text.secondary", mt: 0.5, lineHeight: 1.45 }}>
                {option.description}
            </Box>
        </Box>
    );
}

export default function KayttokohdeField({ value, onChange, error, helperText, required }) {
    const t = useT();
    const options = useMemo(() => kayttokohdeOptions(t), [t]);
    const renderSelectedValue = useCallback((selected) => {
        if (!selected) return "";
        return labelFor(options, selected, selected);
    }, [options]);
    return (
        <TextField
            label={t("wizard.shared.kayttokohdeLabel")}
            select
            fullWidth
            required={required}
            value={value || ""}
            onChange={(e) => onChange(e)}
            error={error}
            helperText={helperText}
            sx={!value ? (theme) => ({
                "& .MuiOutlinedInput-root:not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.custom?.wizard?.amber ?? "#E8893B",
                },
            }) : undefined}
            slotProps={{
                select: {
                    renderValue: renderSelectedValue,
                    MenuProps: {
                        slotProps: {
                            paper: {
                                sx: {
                                    // Capped so the menu fits below the field (matches the
                                    // MuiSelect default in themes.js); a taller menu flips up
                                    // over the cursor and MUI's open-on-mousedown ghost-selects.
                                    maxHeight: 400,
                                    width: { xs: "calc(100vw - 32px)", sm: 460 },
                                    maxWidth: "calc(100vw - 32px)",
                                },
                            },
                        },
                    },
                }
            }}
        >
            {options.map((opt) => (
                <MenuItem
                    key={opt.value}
                    value={opt.value}
                    sx={{
                        whiteSpace: "normal",
                        alignItems: "flex-start",
                        py: 1,
                        px: 2,
                        borderTop: (t) => `1px solid ${t.palette.divider}`,
                        "&:first-of-type": { borderTop: "none" },
                    }}
                >
                    <RichItem option={opt} />
                </MenuItem>
            ))}
        </TextField>
    );
}
